var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4083 29.3067C14.5283 29.3067 12.635 28.5867 11.2083 27.16L5.16833 21.12C3.70167 19.6533 2.92833 17.6267 3.02166 15.56L3.34166 8.89333C3.48833 5.70667 6.00833 3.18667 9.20833 3.02667L15.875 2.70667C17.9417 2.62667 19.9683 3.38667 21.435 4.85333L27.475 10.8933C30.3417 13.76 30.3417 18.44 27.475 21.3067L21.6217 27.16C20.1817 28.5867 18.3017 29.3067 16.4083 29.3067ZM6.58166 19.6933L12.6217 25.7333C13.635 26.7467 14.9817 27.3067 16.4083 27.3067C17.835 27.3067 19.1817 26.7467 20.195 25.7333L26.0483 19.88C27.0617 18.8667 27.6217 17.52 27.6217 16.0933C27.6217 14.6667 27.0617 13.32 26.0483 12.3067L20.0083 6.26667C18.9417 5.2 17.4617 4.62667 15.9683 4.70667L9.30166 5.02667C7.12833 5.12 5.435 6.81333 5.32833 8.97333L5.00833 15.64C4.94167 17.1467 5.515 18.6267 6.58166 19.6933Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9816 17C10.595 17 8.64832 15.0533 8.64832 12.6667C8.64832 10.28 10.595 8.33333 12.9816 8.33333C15.3683 8.33333 17.315 10.28 17.315 12.6667C17.315 15.0533 15.3683 17 12.9816 17ZM12.9816 10.3333C11.7016 10.3333 10.6483 11.3867 10.6483 12.6667C10.6483 13.9467 11.7016 15 12.9816 15C14.2616 15 15.315 13.9467 15.315 12.6667C15.315 11.3867 14.2616 10.3333 12.9816 10.3333Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.a2aa44a4.svg";
export { ForwardRef as ReactComponent };